import { useFlaggedReports, useRejectReport } from '../../hooks/useAdmin'
import { SPECIES_LABELS, EVENT_TYPE_LABELS } from '../../constants/taxonomy'
import type { SpeciesBucket, EventType } from '../../types/contact'

export default function AdminFlaggedReportsPage() {
  const { data, isLoading, isError } = useFlaggedReports()
  const rejectMutation = useRejectReport()

  return (
    <div>
      <h1 className="text-lg font-semibold text-gray-900 mb-1">Flagged reports</h1>
      <p className="text-sm text-gray-500 mb-4">
        Reports users have flagged for review. Rejecting excludes the report from its
        contact's fusion state — the contact is voided if this was its last report.
      </p>

      {isLoading && <p className="text-sm text-gray-500">Loading flagged reports…</p>}
      {isError && <p className="text-sm text-red-600">Failed to load flagged reports.</p>}
      {data && data.length === 0 && <p className="text-sm text-gray-500">Nothing flagged.</p>}

      <div className="space-y-3">
        {data?.map((r) => (
          <div key={r.id} className="rounded-xl border border-gray-200 bg-white px-4 py-3">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-gray-900">
                    {SPECIES_LABELS[r.species_bucket as SpeciesBucket] ?? r.species_bucket}
                  </span>
                  <span className="text-xs text-gray-500">
                    {EVENT_TYPE_LABELS[r.event_type as EventType] ?? r.event_type}
                  </span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-amber-100 text-amber-800">
                    {r.flag_count} flag{r.flag_count === 1 ? '' : 's'}
                  </span>
                </div>
                {r.description && <p className="text-sm text-gray-700 mt-1">{r.description}</p>}
                {r.flag_reason && (
                  <p className="text-xs text-amber-700 mt-1">Reason: {r.flag_reason}</p>
                )}
                <p className="text-xs text-gray-400 mt-1">
                  reporter tier {r.reporter_tier} · reported {new Date(r.reported_at).toLocaleString()}
                </p>
              </div>
              <button
                type="button"
                disabled={rejectMutation.isPending || r.status === 'rejected'}
                onClick={() => rejectMutation.mutate(r.id)}
                className="shrink-0 rounded-lg bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white text-xs font-semibold px-3 py-1.5 transition"
              >
                {r.status === 'rejected' ? 'Rejected' : 'Reject'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
